import React from 'react';
import KickImage from 'Reuseables/KickImage';
import {
Button
} from 'reactstrap';
// import IconSearch from '../../images/magnifier.png';
import IconSearch from '../../images/magnifying-glass-new.png';
// import FontAwesome from 'react-fontawesome';

export default class InputSearch extends React.PureComponent{
  render() {
    return (
      <Button {...this.props} className="btn-green btn--search">
        {/* <KickImage className="btn--search__icon" src={IconSearch} alt="icon search"/> */}
        <p className="btn--search__text">Cari Sneakers</p>
      </Button>
    )
  }
}
